import { TbClock, TbMail, TbMapPin, TbPhone } from 'react-icons/tb';
import { COLORS } from 'utilities';
import { __ContactUsItemType } from './contactUs.type';

const ICON_SIZE = 22;

// Office coordinates — also used to build the map link and the marker position.
export const __ContactUsLocation = {
    latitude: 35.990781,
    longitude: 45.889011,
};

export const __ContactUsPhone = '09359344433';
export const __ContactUsEmail = 'K_k_1367baneh@yahoo.com';
export const __ContactUsAddress = 'کردستان، بانه، شهرک سرچنار، جاده سلیمانیه، کوچه مه یلان 27، طبقه همکف';

export const __ContactUsItems: __ContactUsItemType[] = [
    {
        icon: <TbMapPin size={ICON_SIZE} color={COLORS.primary} />,
        title: 'نشانی',
        value: __ContactUsAddress,
    },
    {
        icon: <TbPhone size={ICON_SIZE} color={COLORS.primary} />,
        title: 'تلفن تماس',
        value: __ContactUsPhone,
        href: 'tel:' + __ContactUsPhone,
    },
    {
        icon: <TbMail size={ICON_SIZE} color={COLORS.primary} />,
        title: 'پست الکترونیک',
        value: __ContactUsEmail,
        href: 'mailto:' + __ContactUsEmail,
    },
    {
        icon: <TbClock size={ICON_SIZE} color={COLORS.primary} />,
        title: 'ساعات پاسخگویی',
        value: 'همه روزه از ساعت ۹:۰۰ تا ۱۷:۰۰',
    },
];
